// frontend/src/pages/Careers.js
import '../custom.css'
import React from 'react'
import { Container, Row, Col, Image, Button, Card } from 'react-bootstrap'

const heroImg =
  'https://images.pexels.com/photos/3183175/pexels-photo-3183175.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1200'

export default function Careers () {
  return (
    <>
      {/* Hero */}
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>Careers at Greatly Social</h1>
          <p className='lead mb-4'>
            Build the future of social marketing — from anywhere in the world.
          </p>
          <Button variant='primary' size='lg' href='mailto:jobs@greatlysocial.com'>
            View Open Roles
          </Button>
        </Container>
      </section>

      {/* Benefits */}
      <section className='py-5'>
        <Container fluid='lg'>
          <Row className='align-items-center g-5'>
            <Col md={6}>
              <Image src={heroImg} alt='Remote work' fluid className='shadow-card rounded-4' />
            </Col>
            <Col md={6}>
              <h2 className='fw-bold mb-4'>Work where you’re happiest</h2>
              {[
                ['Remote-first',            'Work from home, a co-working space, or the beach. Your choice.'],
                ['Flexible hours',          'Set a schedule that fits your life, not the other way around.'],
                ['Annual learning budget',  '$1,000 USD for courses, books, or conferences.'],
                ['Top-tier hardware',       'Latest MacBook Pro and a budget for your ideal setup.'],
              ].map(([title, desc]) => (
                <p key={title} className='mb-3'>
                  <strong>{title} —</strong> <span className='text-muted'>{desc}</span>
                </p>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Open roles */}
      <section className='py-5 bg-light'>
        <Container fluid='lg'>
          <h2 className='fw-bold text-center mb-4'>Current openings</h2>
          <Row className='g-4 justify-content-center'>
            {[
              ['Senior React Engineer',        'Remote • Engineering • Full-time'],
              ['Product Designer',             'Remote • Design • Full-time'],
              ['Customer Success Specialist',  'North America • Support • Full-time'],
            ].map(([role, meta]) => (
              <Col md={4} key={role}>
                <Card className='h-100 shadow-card'>
                  <Card.Body className='d-flex flex-column'>
                    <h5 className='fw-semibold mb-2'>{role}</h5>
                    <p className='text-muted mb-4'>{meta}</p>
                    <Button
                      as='a'
                      href='mailto:jobs@greatlysocial.com'
                      variant='outline-primary'
                      className='mt-auto'
                      size='sm'
                    >
                      Apply&nbsp;now
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  )
}
